/**
 * Thin TanStack adapter over PaginationToolbar (Unit 6,
 * insurescope-7149k.2.3.4). Public API frozen (mui-to-shadcn Pattern 7):
 * the five table consumers keep passing `{ table, entityLabel }` and the
 * rendered output is identical to the pre-extraction component. All
 * presentational chrome lives in PaginationToolbar; this file only maps
 * the table-instance reads onto its props (1-based page convention).
 */
import { type Table } from "@tanstack/react-table";

import { PaginationToolbar } from "./PaginationToolbar";

interface DataTablePaginationProps<TData> {
    table: Table<TData>;
    entityLabel?: string;
}

export function DataTablePagination<TData>({
    table,
    entityLabel = "rows",
}: DataTablePaginationProps<TData>) {
    const { pageIndex, pageSize } = table.getState().pagination;

    return (
        <PaginationToolbar
            total={table.getRowCount()}
            page={pageIndex + 1}
            pages={table.getPageCount()}
            pageSize={pageSize}
            canPreviousPage={table.getCanPreviousPage()}
            canNextPage={table.getCanNextPage()}
            onPageChange={(targetPage) => table.setPageIndex(targetPage - 1)}
            onPageSizeChange={(size) => table.setPageSize(size)}
            entityLabel={entityLabel}
            selectedCount={table.getFilteredSelectedRowModel().rows.length}
            selectedOf={table.getFilteredRowModel().rows.length}
        />
    );
}
